import styled from "styled-components";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();

  let today = new Date();
  let year = today.getFullYear();
  return (
    <Container>
      <div className="box">
        <p>
          © {t("footer")} 2021 - {year}
        </p>
      </div>
    </Container>
  );
};

export default Footer;

const Container = styled.footer`
  background: #559ed6;
  left: 0;
  bottom: 0;
  width: 100%;
  color: white;
  text-align: center;

  @media screen and (max-width: 1023px) {
    position: static;
    margin-top: 20px;
  }

  .box {
    margin: 0 auto;
    max-width: 1320px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 18px;

    @media screen and (max-width: 1119px) {
      max-width: 700px;
    }

    @media screen and (max-width: 767px) {
      max-width: 500px;
    }

    & p {
      font-size: 14px;
      color: #fff;
      white-space: nowrap;
      font-weight: 300;

      @media screen and (max-width: 767px) {
        font-size: 12px;
      }
    }
  }
`;
